let navigation = require('../support/Navigation');

/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */

$(function () {
    'use strict';

    /**
     * Display sidebar menu.
     */
    // Display menu.
    $('.menu-toggle').click((e) => {
        e.preventDefault();

        if ($('.menu').hasClass('active')) {
            $('.menu').addClass('fadeOutMenu');
            $('.menu-backdrop').addClass('fadeOutBackdrop');

            setTimeout((_) => {
                $('.menu').removeClass('active').removeClass('fadeOutMenu');
                $('.menu-backdrop').removeClass('fadeOutBackdrop');
                $('body, html').removeClass('overflow-hidden');
            }, 300);
        } else {
            $('.menu').toggleClass('active');
            $('body, html').toggleClass('overflow-hidden');
        }
    });

    // Hide menu.
    $(document).keyup((e) => {
        if (e.key === 'Escape' && window.innerWidth > 767) {
            $('.menu').addClass('fadeOutMenu');
            $('.menu-backdrop').addClass('fadeOutBackdrop');

            setTimeout((_) => {
                $('.menu').removeClass('active').removeClass('fadeOutMenu');
                $('.menu-backdrop').removeClass('fadeOutBackdrop');

                if (!$('[ignore-escape="true"]').length) {
                    $('body, html').removeClass('overflow-hidden');
                }
            }, 300);

            if ($('.search-no-results').length || $('.search-results').length) {
                $('.search-no-results').css('display', 'none');
                $('.search-results').css('display', 'none');
            }
        }
    });

    // Display responsive search.
    $('.search-responsive-toggle').click((e) => {
        e.preventDefault();

        $('.search-responsive').removeClass('hidden').addClass('flex');
        $('.app-container, .menu-categories-fixed').addClass('search-active');
        $('.search-responsive .search-input').focus();
    });

    // Hidden responsive search.
    $('.search-responsive-close').click((e) => {
        e.preventDefault();

        $('.search-responsive').removeClass('flex').addClass('hidden');
        $('.app-container, .menu-categories-fixed').removeClass('search-active');
        $('.search-clear').addClass('hidden');
        $('.search-responsive .search-input').val('');
    });

    // Display clear input search.
    $('#search, .search-input').keyup(function (e) {
        if ($(e.currentTarget).val()) {
            $('.search-clear').removeClass('hidden');
        } else {
            $('.search-clear').addClass('hidden');
        }
    });

    // Clear input search.
    $('.search-clear').click((e) => {
        e.preventDefault();

        $('#search, .search-input').val('');
        $('.search-clear').addClass('hidden');
    });

    // Hidden search.
    $(window).click(function () {
        if ($('.search-no-results').length || $('.search-results').length) {
            $('.search-no-results').css('display', 'none');
            $('.search-results').css('display', 'none');
        }
    });

    // Display guest navigation only desktop views.
    navigation.navbarGuestToTop('.navigation-guest');

    // Display correct overflow screens.
    if ($('.slider-featured, .slider-home-site').length) {
        const mutation = new MutationObserver((e) => {
            if ($('.container-overflow').height() < $(window).height()) {
                $('.container-overflow').addClass('overflow-height');
            }
        });

        let element = document.querySelector('div.slider-featured') || document.querySelector('div.slider-home-site');

        mutation.observe(element, {
            attributes: true,
        });
    } else {
        if ($('.container-overflow').height() < $(window).height()) {
            $('.container-overflow').addClass('overflow-height');
        }
    }

    /**
     * Check if category or subcategory menu is overflow and if the container is smaller.
     */
    $('.menu-categories, .menu-subcategories').each(function (i, e) {
        if ($(e).prop('scrollWidth') <= $(e).closest($('.simplebar-custom-horizontal')).width()) {
            $(e).addClass('lg:justify-center');
        }
    });

    /**
     * show selected element when it is hidden by overflow.
     */
    $.fn.scrollCenter = function (e) {
        $(this).animate(
            {
                scrollLeft: $(this).scrollLeft() - $(this).offset().left + $(e).offset().left,
            },
            300
        );
        return this;
    };

    $('.simplebar-custom-horizontal').each(function (i, e) {
        if ($(e).find('.active').length) {
            $(e).find('.simplebar-content-wrapper').scrollCenter($(e).find('.active'));
        }
    });
});
